import "lib/polyfills";
import "styles/tailwind.css";
import "lib/monkeyPatching";

import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import { initSentry, Sentry } from "lib/sentry";
import WalletProvider from "lib/wallets/WalletProvider";

import App from "./app/App";
import reportWebVitals from "./reportWebVitals";

// Initialize Sentry before rendering the app
initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 p-8 text-white">
        <h1 className="mb-4 text-2xl font-bold">Something went wrong</h1>
        <p className="mb-4 text-gray-400">An unexpected error occurred. Our team has been notified.</p>
        <pre className="mb-6 max-w-lg overflow-auto rounded bg-slate-800 p-4 text-sm text-red-400">
          {error?.toString()}
        </pre>
        <button
          onClick={resetError}
          className="rounded bg-blue-600 px-6 py-2 text-white hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    )}
    onError={(error) => {
      console.error("[Sentry ErrorBoundary] Caught error:", error);
    }}
  >
    <Router>
      <WalletProvider>
        <App />
      </WalletProvider>
    </Router>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export { formatTokenAmount, formatTokenAmountWithUsd, formatUsd } from "lib/numbers";
